import { EventbriteHeader } from '@eventbrite/webapp-constants';
import { getLocaleFromRequest } from '@eventbrite/webapp-locales';
import { IncomingMessage } from 'http';

export function getRequestContext(req?: IncomingMessage) {
    const hostHeader = req?.headers[EventbriteHeader.EB_HOST] as string;
    const localeHeader = req?.headers[EventbriteHeader.EB_LANG] as string;
    const host = hostHeader || 'www.eventbrite.com';
    const tld = (host.match(/(?:evbqa|evbstage|eventbrite)(\.\S+)$/) || [])[1];
    const serverUrl = `https://${host}${req?.url || ''}`;
    const locale = localeHeader || (req ? getLocaleFromRequest(req) : '');

    return {
        tld,
        host,
        serverUrl,
        locale,
    };
}
